import { useYearQuarterNavigation } from 'hooks';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';

import { capacityBalanceAtom } from '../../atoms';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead
} from '@mui/material';

import { NumericTableCell } from 'components/shared/Table';
import TableHeaderRow from 'components/shared/Table/TableHeaderRow';

import { renderPeriodColumnHeaders } from '../../util';
import CollapsibleCapacityBalanceTableRow from './CollapsibleCapacityBalanceTableRow';

const CapacityBalanceTable = () => {
  const { t } = useTranslation('common');
  const { isViewPerWeek } = useYearQuarterNavigation();
  const capacityBalance = useRecoilValue(capacityBalanceAtom);

  return (
    capacityBalance && (
      <TableContainer component={Paper}>
        <OverlayScrollbarsComponent style={{ maxWidth: '100%' }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableHeaderRow>
                <TableCell width={200} />
                {renderPeriodColumnHeaders(
                  capacityBalance.periodHourBalances,
                  isViewPerWeek
                )}
                <NumericTableCell width={68}>{t('yearTotal')}</NumericTableCell>
              </TableHeaderRow>
            </TableHead>
            <TableBody>
              {capacityBalance && (
                <CollapsibleCapacityBalanceTableRow
                  capacityBalance={capacityBalance}
                />
              )}
            </TableBody>
          </Table>
        </OverlayScrollbarsComponent>
      </TableContainer>
    )
  );
};

export default CapacityBalanceTable;
